module.exports = __webpack_public_path__ + "img/background.34edf49a.jpg";